import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import React,{useContext} from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom';
import styles from './Navigation.module.css'
import Grades from '../Grades/Grades.js'
import {context} from '../../context'

const Navigation = () => {
  const {showItem,setShowItem,id} = useContext(context)
  return (
    <div>
      <Navbar bg="light" expand="lg" className={styles.navbar} fixed="top">
        <Navbar.Brand href="#home"><img src="img/m logo.png" width="50" height="50" alt="" />
          <h3 className="d-inline align-middle" style={{ color: "#98426a" }}>Mr.Mack</h3></Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link onClick={()=>setShowItem("book site")} href="#showcase" className={styles.navItem}>Home</Nav.Link>
            <Nav.Link onClick={()=>setShowItem("book site")} href="#About" className={styles.navItem}>About</Nav.Link>
            <Nav.Link onClick={()=>setShowItem("book site")} href="#Author" className={styles.navItem}>Author and book Sample</Nav.Link>
            <Nav.Link onClick={()=>setShowItem("book site")} href="#contact" className={styles.navItem}>Contact</Nav.Link>
            <NavDropdown title="Log In" id="nav-dropdown" className={styles.navItem}>
              <NavDropdown.Item eventKey="1" onClick={()=>setShowItem("sign in")}>Sign In </NavDropdown.Item>
              <NavDropdown.Item onClick={()=>setShowItem("log in")} eventKey="2">Sign Up</NavDropdown.Item>
              <NavDropdown.Item eventKey="3" onClick={
                fetch('https://englishtutorial1.somee.com/api/Account/Logout',{
                  method: 'POST'
                })
                .then(data=>data.json())
                .then(res=>console.log(res))
              }>Log Out </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
        <Grades />
      </Navbar>
    </div>
  )
}

export default Navigation
